module.exports = __webpack_public_path__ + "static/img/empty.88242683.svg";